<script setup lang="ts">
import { supabase } from '@/composables/supabaseClient'
import toastThrowError from '@/helpers/toastThrowError'
import uuidv7 from '@/helpers/uuidv7'
import { useDatabaseStore } from '@/stores/databaseStore'
import { ref } from 'vue'
import BaseButton from './BaseButton.vue'
import BaseInput from './BaseInput.vue'

const databaseStore = useDatabaseStore()

const newStatusName = ref('')

async function saveNewSource() {
  if (newStatusName.value === '') throw toastThrowError('New Estimate Status Name is Required')
  const result = await supabase
    .from('estimate_status')
    .insert({ id: uuidv7(), name: newStatusName.value })
    .select()
    .single()
  if (result.error) throw toastThrowError('Unable to create estimate status', result.error)
  databaseStore.estimateStatus?.push(result.data)
  newStatusName.value = ''
}
</script>

<template>
  <div class="flex h-full w-full flex-col gap-3 p-3">
    <span class="font-bold">Estimate Status</span>
    <div v-for="estimateStatus in databaseStore.estimateStatus" :key="estimateStatus.id">
      {{ estimateStatus.name }}
    </div>
    <BaseInput
      v-model="newStatusName"
      class="w-full border p-1"
      placeholder="New Estimate Status..."
    />
    <BaseButton @click="saveNewSource()">Save</BaseButton>
  </div>
</template>
